import classNames from 'classnames';
import type { ReactNode } from 'react';
import styled from 'styled-components';

import { ButtonBase } from '@sorare/core/src/atoms/buttons/ButtonBase';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { iconX } from '@sorare/core/src/atoms/icons/system/iconX.ts';
import {
  LinkBox,
  LinkOther,
  LinkOverlay,
} from '@sorare/core/src/atoms/navigation/Box';
import { BodyM } from '@sorare/core/src/atoms/typography';
import { Chip } from '@sorare/core/src/atoms/ui/Chip';

type Props = {
  label: ReactNode;
  onClick?: () => void;
  onClose?: () => void;
  transparent?: boolean;
};

const StyledText14 = styled(BodyM)`
  padding-left: var(--half-unit);
`;
const StyledLinkOther = styled(LinkOther)`
  padding: 0 var(--unit);
`;
const StyledChip = styled(Chip)`
  background: var(--c-nd-50);

  &:hover,
  &:focus {
    background: var(--c-nd-150);
  }
  &.transparent {
    background: transparent;
  }
`;

export const FilterChip = ({ label, onClick, onClose, transparent }: Props) => {
  return (
    <LinkBox>
      <StyledChip className={classNames({ transparent })} size="medium">
        <LinkOverlay as={onClick ? ButtonBase : 'div'} onClick={onClick}>
          <StyledText14 bold>{label}</StyledText14>
        </LinkOverlay>
        {!!onClose && (
          <StyledLinkOther as={ButtonBase} onClick={onClose}>
            <FontAwesomeIcon icon={iconX} size="xs" />
          </StyledLinkOther>
        )}
      </StyledChip>
    </LinkBox>
  );
};
